import type { StoreSlugs } from '@iheartjane/data-access';

const findPrimarySlugForStore = (
  storeSlugs: StoreSlugs | undefined,
  storeId: number
): string | undefined => {
  if (!storeSlugs) return undefined;

  for (const [slug, entry] of Object.entries(storeSlugs)) {
    if (entry.kind === 'primary' && entry.store_id === storeId) {
      return slug;
    }
  }

  return undefined;
};

export const generateStoreUrl = (
  menuUrl: string,
  storeId: number,
  storeSlugs?: StoreSlugs
) => {
  const primarySlug = findPrimarySlugForStore(storeSlugs, storeId);
  return `${menuUrl}/${primarySlug ?? `store/${storeId}`}`;
};
